import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/DefaultView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/default',
    name: 'default',
    component: () => import('../views/DefaultView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue')
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('../views/DownloadView.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('../views/news/ListView.vue')
  },
  {
    path: '/news/detail',
    name: 'news_detail',
    component: () => import('../views/news/DetailView.vue')
  },
  {
    path: '/company',
    name: 'company',
    component: () => import('../views/company/IndexView.vue')
  },
  {
    path: '/query',
    name: 'query',
    component: () => import('../views/query/IndexView.vue')
  },
  {
    path: '/query/cert',
    name: 'query_cert',
    component: () => import('../views/query/CertView.vue')
  },
  {
    path: '/company/detail',
    name: 'company_detail',
    component: () => import('../views/company/DetailView.vue')
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('../views/news/SearchView.vue')
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('../views/service/IndexView.vue')
  },
  {
    path: '/service/detail',
    name: 'service_detail',
    component: () => import('../views/service/DetailView.vue')
  },
  {
    path: '/member-service',
    name: 'member_service',
    component: () => import('../views/MemberServiceView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/IndexView.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/login/RegisterView.vue')
  },
]

const publicPath = process.env.BASE_URL || '/web';

const router = new VueRouter({
  mode: 'history',
  base: publicPath,
  routes
})

export { publicPath }

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
